import React from 'react';
import Card from 'react-bootstrap/Card';
import classNames from 'classnames';
import BaseProps from '../../../types/BaseProps';

import './BaseWidget.scss';

type BaseWidgetProps = {
  title?: string
  dropShadow?: boolean
  hasErrors?: boolean
  hasWarnings?: boolean
}

class BaseWidget extends React.Component<BaseWidgetProps & BaseProps> {

  public static defaultProps = {
    dropShadow: true,
    hasErrors: false,
    hasWarnings: false
  };

  render() {
    const classes = classNames('BaseWidget', this.props.className, {
      'DropShadow': this.props.dropShadow,
      'border-danger': this.props.hasErrors,
      'border-warning': this.props.hasWarnings
    });
    return (
      <Card className={classes}>
        <Card.Body>
          {this.props.title ? <Card.Title>{this.props.title}</Card.Title> : ''}
          {this.props.children}
        </Card.Body>
      </Card>
    );
  }

}

export default BaseWidget;
